// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapping-container {
    background-size: cover;
    margin: -7px 0 -20px 0;
    padding-top: 50px;
    min-height: calc(100vh - 323px);
}

#hero-wrapper {
    padding-top: 6rem;
}

/* left section */
.hero-left hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #15161d;
    margin: 0 0 1rem 0;
    padding: 0;
}

.list-group-item a {
    text-decoration: none;
}

.job-advert-title {
    color: var(--main-color);
    font-weight: 600;
}

.job-advert-details {
    color: #15161d;
}

.job-advert img {
    margin-top: 8px;
    width: 30px;
    height: 30px;
}

.jobs-see-more {
    background-color: #15161D;
    color: #8D99AE;
    -ms-opacity: .65;
    opacity: .65;
    margin-top: 5px;
}


.jobs-see-more:hover, .jobs-see-more:focus {
    color: #EDF2F4;
    text-decoration: none;
    cursor: pointer;
    opacity: .75;
}

.list-group-item {
    background: transparent;
    line-height: 1.2;
    font-size: 14px;
    border: none;
    padding: 6px;
    border-radius: 0;
    transition: 0.3s;
}

.list-group-item:hover {
    background-color: rgba(255,255,255,0.4);
}



/* right section */

.main-header {
    color: #fff;
    margin-top: -10px;
}

.main-header h1{
    font-size: 4.6rem;
    font-weight: 400;
    margin-bottom: 10px;
}

.main-header h3 {
    font-weight: 400;
    margin-bottom: 30px;
}


.form-group.text-input {
    padding: 10px 0px;
}

    .form-group.text-input input.form-control {
        padding: 8px;
        border-radius: 2px;
        background: rgba(255,255,255,0.6);
    }

select.form-control:not([size]):not([multiple]) {
        height: calc(2.25rem + 6px);
        border-radius: 2px;
        background: rgba(255,255,255,0.6);
    }

::ng-deep #location-search .form-group input.form-control {
    padding: 8px;
    background: rgba(255,255,255,0.6);
    margin-top: 15px;
    border-radius: 2px !important;
}

::ng-deep location-search #pointer {
    top: 10px;
}

#distance:disabled {
    background-color: #bbb;
    cursor: not-allowed;
}

.form-group {
    margin-bottom: 0px;
}

.form-group button {
    margin-top: 10px; 
}

.form-group.location {
    position: relative;
}

.location span {
    position: absolute;
    top: 20px;
    right:8px;
    cursor: pointer;
}
.location span i:active, span i:visited {
    color: #aaa;
}

.btn-search {
    margin-bottom: 30px;
    border: 2px solid #888;
    border-radius: 2px;
    font-size: 1.2rem;
    font-weight: 500;
    padding: 10px;
    cursor: pointer;
    background-color: var(--main-color);
    color: #fff;
}

    .btn-search:hover,
    .btn-search:active,
    .btn-search:focus {
        color: #fff;
        background-color: var(--secondary-color);
        border-color: var(--secondary-color);
        box-shadow: 0 0 0 0.2rem var(--main-color);
        cursor: pointer;
    }




@media (max-width: 996px) {
    .live-jobs {
        margin-right: 0;
        text-align: center;
    }

    .main-header h1 {
        font-size: 3rem;
        font-weight: 400;
    }

    .main-header {
        text-align: center;
        margin-top: 20px;
        padding-bottom: 20px;
        font-weight: 500;
        border-radius: 5px;
        margin-left: 0;
    }

    .main-header h1 {
        font-size: 4rem;
    }
}

@media (max-width: 768px) {
    .main-header h1 {
        font-size: 3rem;
        font-weight: 400;
    }

    .main-header {
        margin-left: 0;
    }

    .hero-left {
        width: 100%;
        margin: 30px 0 0 0; 
    }

    .search-form {
        margin-right: 0px;
    }

    #hero-wrapper {
        padding-top: 0;
    }

    #hero-wrapper .main-header {
        margin-top: 2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/job-latest/job-latest.component.css"],"names":[],"mappings":"AAAA;IAII,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA,iBAAiB;AACjB;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;;AAGA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,YAAY;IAEZ,gBAAgB;IAIhB,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;AAC3C;;;;AAIA,kBAAkB;;AAElB;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,iBAAiB;AACrB;;IAEI;QACI,YAAY;QAEZ,kBAAkB;QAClB,iCAAiC;IACrC;;AAEJ;QACQ,2BAA2B;QAC3B,kBAAkB;QAClB,iCAAiC;IACrC;;AAEJ;IACI,YAAY;IACZ,iCAAiC;IACjC,gBAAgB;IAEhB,6BAA6B;AACjC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,eAAe;AACnB;AACA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IAEtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,mCAAmC;IACnC,WAAW;AACf;;IAEI;;;QAGI,WAAW;QACX,wCAAwC;QACxC,oCAAoC;QACpC,0CAA0C;QAC1C,eAAe;IACnB;;;;;AAKJ;IACI;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;QACpB,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".wrapping-container {\r\n    -webkit-background-size: cover;\r\n    -moz-background-size: cover;\r\n    -o-background-size: cover;\r\n    background-size: cover;\r\n    margin: -7px 0 -20px 0;\r\n    padding-top: 50px;\r\n    min-height: calc(100vh - 323px);\r\n}\r\n\r\n#hero-wrapper {\r\n    padding-top: 6rem;\r\n}\r\n\r\n/* left section */\r\n.hero-left hr {\r\n    display: block;\r\n    height: 1px;\r\n    border: 0;\r\n    border-top: 1px solid #15161d;\r\n    margin: 0 0 1rem 0;\r\n    padding: 0;\r\n}\r\n\r\n.list-group-item a {\r\n    text-decoration: none;\r\n}\r\n\r\n.job-advert-title {\r\n    color: var(--main-color);\r\n    font-weight: 600;\r\n}\r\n\r\n.job-advert-details {\r\n    color: #15161d;\r\n}\r\n\r\n.job-advert img {\r\n    margin-top: 8px;\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n\r\n.jobs-see-more {\r\n    background-color: #15161D;\r\n    color: #8D99AE;\r\n    -ms-opacity: .65;\r\n    opacity: .65;\r\n    margin-top: 5px;\r\n}\r\n\r\n\r\n.jobs-see-more:hover, .jobs-see-more:focus {\r\n    color: #EDF2F4;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n    opacity: .75;\r\n}\r\n\r\n.list-group-item {\r\n    background: transparent;\r\n    line-height: 1.2;\r\n    font-size: 14px;\r\n    border: none;\r\n    padding: 6px;\r\n    -ms-border-radius: 0;\r\n    border-radius: 0;\r\n    -ms-transition: 0.3s;\r\n    -o-transition: 0.3s;\r\n    -webkit-transition: 0.3s;\r\n    transition: 0.3s;\r\n}\r\n\r\n.list-group-item:hover {\r\n    background-color: rgba(255,255,255,0.4);\r\n}\r\n\r\n\r\n\r\n/* right section */\r\n\r\n.main-header {\r\n    color: #fff;\r\n    margin-top: -10px;\r\n}\r\n\r\n.main-header h1{\r\n    font-size: 4.6rem;\r\n    font-weight: 400;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.main-header h3 {\r\n    font-weight: 400;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n\r\n.form-group.text-input {\r\n    padding: 10px 0px;\r\n}\r\n\r\n    .form-group.text-input input.form-control {\r\n        padding: 8px;\r\n        -ms-border-radius: 2px;\r\n        border-radius: 2px;\r\n        background: rgba(255,255,255,0.6);\r\n    }\r\n\r\nselect.form-control:not([size]):not([multiple]) {\r\n        height: calc(2.25rem + 6px);\r\n        border-radius: 2px;\r\n        background: rgba(255,255,255,0.6);\r\n    }\r\n\r\n::ng-deep #location-search .form-group input.form-control {\r\n    padding: 8px;\r\n    background: rgba(255,255,255,0.6);\r\n    margin-top: 15px;\r\n    -ms-border-radius: 2px !important;\r\n    border-radius: 2px !important;\r\n}\r\n\r\n::ng-deep location-search #pointer {\r\n    top: 10px;\r\n}\r\n\r\n#distance:disabled {\r\n    background-color: #bbb;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.form-group button {\r\n    margin-top: 10px; \r\n}\r\n\r\n.form-group.location {\r\n    position: relative;\r\n}\r\n\r\n.location span {\r\n    position: absolute;\r\n    top: 20px;\r\n    right:8px;\r\n    cursor: pointer;\r\n}\r\n.location span i:active, span i:visited {\r\n    color: #aaa;\r\n}\r\n\r\n.btn-search {\r\n    margin-bottom: 30px;\r\n    border: 2px solid #888;\r\n    -ms-border-radius: 2px;\r\n    border-radius: 2px;\r\n    font-size: 1.2rem;\r\n    font-weight: 500;\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    background-color: var(--main-color);\r\n    color: #fff;\r\n}\r\n\r\n    .btn-search:hover,\r\n    .btn-search:active,\r\n    .btn-search:focus {\r\n        color: #fff;\r\n        background-color: var(--secondary-color);\r\n        border-color: var(--secondary-color);\r\n        box-shadow: 0 0 0 0.2rem var(--main-color);\r\n        cursor: pointer;\r\n    }\r\n\r\n\r\n\r\n\r\n@media (max-width: 996px) {\r\n    .live-jobs {\r\n        margin-right: 0;\r\n        text-align: center;\r\n    }\r\n\r\n    .main-header h1 {\r\n        font-size: 3rem;\r\n        font-weight: 400;\r\n    }\r\n\r\n    .main-header {\r\n        text-align: center;\r\n        margin-top: 20px;\r\n        padding-bottom: 20px;\r\n        font-weight: 500;\r\n        border-radius: 5px;\r\n        margin-left: 0;\r\n    }\r\n\r\n    .main-header h1 {\r\n        font-size: 4rem;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .main-header h1 {\r\n        font-size: 3rem;\r\n        font-weight: 400;\r\n    }\r\n\r\n    .main-header {\r\n        margin-left: 0;\r\n    }\r\n\r\n    .hero-left {\r\n        width: 100%;\r\n        margin: 30px 0 0 0; \r\n    }\r\n\r\n    .search-form {\r\n        margin-right: 0px;\r\n    }\r\n\r\n    #hero-wrapper {\r\n        padding-top: 0;\r\n    }\r\n\r\n    #hero-wrapper .main-header {\r\n        margin-top: 2rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
